import Carousel from 'react-bootstrap/Carousel';

function ImageCarousel({ data }) {
  return (
    <div className='h-full w-full'>
      <Carousel variant='dark' slide={true} className='h-full w-full'>
        {data && data.map((image, index) => {
          return (
            <Carousel.Item key={index} className='h-full w-full'>
              <div style={{ width: '100%', height: '22rem' }} className="rounded overflow-auto">
                <img
                  src={image}
                  alt={`Business Image`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </Carousel.Item>
          );
        })}
      </Carousel>
    </div>
  );
}

export default ImageCarousel;
